/**
 * B2B-320 — nomes de evento de telemetria de conquistas, centralizados aqui
 * (espelha o enum EAchievementEvent do backend). Genérico por conquista: a
 * chave de fora é o `achievement_type`, então uma conquista futura (5 vendas,
 * 10 vendas, etc — ver "Visão de Evolução" do card) só precisa de um bloco
 * novo aqui, sem duplicar nomes espalhados em componentes.
 */
export default {
  FIRST_SALE: {
    ACHIEVEMENT_GENERATED: 'first_sale_achievement_generated',
    MODAL_VIEWED: 'first_sale_modal_viewed',
    CLOSED: 'first_sale_closed',
    IMAGE_DOWNLOADED: 'first_sale_image_downloaded',
    SHARE_CLICKED: 'first_sale_share_clicked',
    SHARE_COMPLETED: 'first_sale_share_completed',
  },
};
